import styled, { css } from 'styled-components';
import { shade } from 'polished';
import { Search, Delete } from 'react-iconly';

export const Main = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: var(--background);

  h1 {
    font-size: 3.6rem;
    font-weight: 500;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 500;
  }

  .header-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 274px;
      height: 47px;
      margin-right: 40px;
      font-size: 1.6rem;
    }
  }
`;

export const Section = styled.div`
  background: #fcfcfc;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 20px 40px 40px 38px;

  h2 {
    font-size: 2.4rem;
    font-weight: 500;
    color: var(--primary);
  }

  button.allItems {
    float: right;
    width: 274px;
    height: 47px;
    background: transparent;
    border: 2px solid var(--red);
    font-size: 1.6rem;
    font-weight: 400;
    color: var(--red);
    transition: background-color 0.2s;

    &:hover {
      color: ${(shade(0.2), '#BF1E2D')};
    }
  }

  .flex-container {
    display: flex;
    flex-direction: column;
    align-items: left;
    text-align: left;
    background: var(--table-color);
    box-shadow: 0px 20px 20px -2px rgba(0, 0, 0, 0.05);

    margin: 25px 0 20px 5px;
    padding: 40px;

    > div {
      display: flex;
      justify-content: space-between;
    }

    .deleteItem {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: -35px;

      > button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 274px;
        height: 47px;
        font-size: 1.6rem;
        font-weight: 400;
        svg {
          width: 2rem;
          margin-left: 10px;
        }
      }
    }
    .searchBar {
      width: 589px;
      height: 47px;
      float: left;
      display: flex;
      margin-top: 40px;
      margin-bottom: 20px;
      align-items: right;

      h5 {
        font-size: 1.6rem;
      }

      > svg {
        position: absolute;
        float: right;
        width: 20px;
        height: 20px;
        margin: 15px 10px 0 30px;
      }

      input {
        float: right;
        padding-left: 50px;
        width: 560px;
      }
    }

    .listAddress {
      display: flex;
      justify-content: space-between;
      > div > div {
        margin-top: 10px;
      }
    }

    .bottomPedidos {
      display: flex;
      margin-top: 45px;
      padding-bottom: 10px;
      > button {
        margin-right: 44px;
        margin-top: 0;
        margin-bottom: 60px;
      }
    }
  }

  .tabs-container {
    position: relative;
    height: 1200px;
    width: 100%;
    max-width: 995px;
    left: 0;
    margin: 34px 0;
  }

  .tabs-container:after {
    content: '.';
    display: block;
    clear: both;
    height: 0;
    font-size: 0;
    line-height: 0;
    visibility: none;
  }
  input.tabs {
    display: none;
  }
  input.tabs + label {
    width: 320px;
    height: 60px;
    line-height: 40px;
    padding: 10px 10px;
    text-align: center;
    background: #f3f3f3;
    color: var(--secondary);
    cursor: pointer;
    transition: background ease-in-out 0.3s;
    font-size: 1.8rem;
  }

  input.tabs:checked + label {
    color: var(--primary);
    background: var(--background);
    border-top: 2px solid var(--primary);
  }

  input.tabs + label + div {
    margin-right: 100px;
    width: 100%;
    opacity: 0;
    position: absolute;
    top: 150px;
    left: 0;
    height: 500px;
    padding: 10px;
    z-index: -1;
    transition: opacity ease-in-out 0.3s;
  }
  input.tabs:checked + label + div {
    & + input {
    }
    opacity: 1;
    z-index: 1000;
  }
`;

const iconCSS = css`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;

export const SearchIcon = styled(Search)`
  ${iconCSS}
`;
export const DeleteIcon = styled(Delete)`
  ${iconCSS}
`;

export const FormCadastroPequenosAlmocos = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .formulario-cadastro {
    margin-top: 10px;

    div {
      display: flex;
      align-items: left;
      justify-content: left;
      & + div {
        margin-bottom: 30px;
      }
    }

    .form-inputs {
      display: flex;
      flex-direction: column;
      margin-right: 50px;

      h5 {
        font-size: 1.6rem;
        font-weight: 400;
        margin: 20px 0 10px 10px;
      }

      input {
        border: 0;
        border-radius: 20px;
        width: 600px;
        height: 30px;
        padding: 10px 10px;
        background: var(--input);
      }
      input.input-valor {
        width: 167px;
      }
      input.input-numero {
        width: 100px;
      }
      .form-textarea {
        max-width: 630px;
        width: 630px;
        height: 150px;
        background: var(--input);
        border: 0;
        border-radius: 20px;
        padding: 20px;
        font-size: 1.6rem;
        font-family: 'Rubik';
        color: var(--secondary);
      }

      .select-options {
        border: 0;
        border-radius: 20px;
        width: 320px;
        height: 47px;
        background: var(--input);
        padding: 10px 20px;
        ::placeholder {
          font-size: 1.6px;
          font-weight: 400;
          color: var(--secondary);
        }
      }
    }
  }

  .morada {
    margin-top: 30px;

    h2 {
      font-size: 2.4rem;
      font-weight: 500;
    }
  }
`;
